import { ref } from 'vue'
import { patch } from '@rails/request.js'
import { useSaveStatus } from './useSaveStatus'

export function useLessonUpdate() {
  const { setStatus, setStatusToLastSaved, setIsSaving } = useSaveStatus()
  const error = ref(null)

  const updateLessonSettings = async (updatePath, body, headers = { 'Content-Type': 'application/json' }, responseKind = 'json') => {
    const startTime = Date.now()
    setStatus('Saving...')
    setIsSaving(true)
    error.value = null

    try {
      const response = await patch(updatePath, {
        body,
        headers,
        responseKind
      })

      if (response.ok) {
        await handleSuccessfulUpdate(startTime)
      } else {
        handleUpdateError(await response.json)
      }
    } catch (err) {
      handleUpdateError(err)
    }
  }

  const handleSuccessfulUpdate = async (startTime) => {
    const elapsedTime = Date.now() - startTime
    const remainingTime = Math.max(0, 1000 - elapsedTime)
    setTimeout(setStatusToLastSaved, remainingTime)
    setIsSaving(false)
  }

  const handleUpdateError = (err) => {
    console.error('Error updating lesson settings:', err)
    error.value = err?.message || 'An unknown error occurred'
    setStatus('⚠️ Error saving')
    setIsSaving(false)
  }

  return {
    updateLessonSettings,
    error
  }
} 